import React from "react";
import { FaWhatsapp } from "react-icons/fa";

export default function WhatsAppButton() {
  const phoneNumber = "919820237527"; // Replace with your WhatsApp number
  const message = "Hello! I want to be part of the movement"; // Optional default message

  const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      className="waicon"
      style={{ color: '#000000', fontSize: '16px', textDecoration: 'None'  }}
    >
    +91-9820237527 <FaWhatsapp size={20} />
    </a>
  );
}
